import seoData from './index';

const DEFAULT_KEY = 'default';

export default ({ location = {} }) => {
  const { pathname } = location;
  const data = seoData[pathname] || {};

  return Object.assign({}, seoData[DEFAULT_KEY], data);
};



// WEBPACK FOOTER //
// ./src/app/data/seo/get_seo_for_page.js